import React, { Component } from "react";
import FlexContainer from "./FlexContainer";
import styled from "styled-components";
import axios from "axios";
import { API_URL, RegionalApiManager, LoginType } from "src/scenes/App";
import MeBusinessLogo from "../img/new/me_business_logo.png";
import CheckedInLogo from "src/img/checked-in/logo-horizontal-cream.png";
import OnPointLogo from "../img/new/on_point_logo.png";
import { LicenseRenewalContainerContext } from "./LicenseRenewalContainerContext";
import Text from "./Text";
import { mobile, tablet, desktop } from "./Media";
import { AppVariant, getAppDetails } from "src/config/appVariants";

/**
 * Class: LicenseHeader Styled components
 *  */ 
const Container = styled.header`
    background: ${p => p.url ? `url(${p.url}) no-repeat center ${p.location || "top"}` : null};
    background-color: ${p => p.transparent ? "transparent" : p.backgroundColor };
    flex: 0;
    top: ${p => p.top};
    transition: background-color 0.3s;
    width: 100%;
`;

const Content = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 32px;
    width: 100%;
    text-align: center;
`;

const Logo = styled.div`
`;

/**
 * Class: LicenseFooter Styled components
 *  */ 
const FooterBox = styled.div`
    width: 100%;
    height: 394px;
    background: ${p => p.backgroundColor} 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #0000006E;
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const FooterContainer = styled.div`
    display: flex;
    flex-direction: column; 
    align-items: center;
    justify-content: center;
    font-size: 14px;
    text-align: center;
    width: 90%;
    color: #fff;
    gap: 1em;
    margin-top: 20px;
`;

const FooterLinksContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    margin: 20px 0 20px 0;
`;

const FooterLink = styled.a`
    font: normal normal medium 14px/19px Manrope;
    letter-spacing: 0px;
    color: #FFFFFF;
    opacity: 1;
    padding: 12px 0;
    text-decoration: none;
    width: auto;
    text-align: center;
    white-space: nowrap;

    ${tablet`
        flex-grow: 0;
        width: auto;
    `};

    ${desktop`
        flex-grow: 0;
        width: auto;
    `};
`;

const OphPowerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 165px;
    height: 17px;

    ${mobile`
        display: table-cell;
        text-align:center;
        padding-bottom: 20px;
    `};
`;

const CopyrightText = styled.div`
    margin-top: 40px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    font-family: Manrope;
`;


const OphImage = styled.img`
    width: 150px;
    height: 1.5em;

    ${desktop`
        height: 1.5em;
    `};
`;

const OphFooterImage = styled.img`
    width: 165px;
    height: 17px;
    margin: 1em;
`;

const OphLink = styled.a`
    text-decoration: none;
    display: flex;
    align-items: center;
    color: inherit;
    gap: 0.5em;
`;

class LicenseRenewalContainer extends Component {
    state = {
        fetching: 0,
        businessLogo: undefined,
        backgroundColor: "#000000",
        licenseTermDuration: undefined,
        licenseTermDurationUnit: undefined,
        licenseTermAmount: undefined,
        isAustralian: undefined,
        gstAmount: undefined,
        currency: undefined,
        chargeAmount: undefined,
        accessToken: "XXXXXX",
        employeeName: "Me App User",
        businessName: "On Point Holdings",
        isValidLicenseRenewalKey: false,
        key: undefined,
        referralCode: undefined,
        errorMessage: undefined,
        licenseStatus: undefined,
        finishDate: undefined,
        processingFee: undefined,
        basePrice: undefined,
        appVariant: AppVariant.ME_BUSINESS,
    };
    
    componentDidMount() {
        this.setState(state => ({
            fetching: state.fetching + 1
        }), () => this.safeToInit());
    }
    
    safeToInit = async () => {
        const referralCode = this.props.match.params.referralCode;
        const key = this.props.match.params.key;

        try {
            const region = await RegionalApiManager.locateUser(LoginType.LicenseUuid, referralCode);
            RegionalApiManager.setRegionData(region); // Assigns API_URL

            const res = await axios.get(`${API_URL}/validateLicenseRenewalKey/${referralCode}/${key}`);
            const validateLicenseRenewalResponse = res.data;

            this.setState({
                isValidLicenseRenewalKey: true,
                employeeName: validateLicenseRenewalResponse.employeeName,
                businessName: validateLicenseRenewalResponse.businessName,
                businessLogo: this.generateImageContainer(validateLicenseRenewalResponse.businessLogo),
                backgroundColor: validateLicenseRenewalResponse.backgroundColor,
                licenseTermDuration: validateLicenseRenewalResponse.licenseTermDuration,
                licenseTermDurationUnit: validateLicenseRenewalResponse.licenseTermDurationUnit,
                licenseTermAmount: validateLicenseRenewalResponse.licenseTermAmount,
                isAustralian: validateLicenseRenewalResponse.isAustralian,
                gstAmount: validateLicenseRenewalResponse.gstAmount,
                processingFee: validateLicenseRenewalResponse.processingFee,
                currency: validateLicenseRenewalResponse.currency,
                chargeAmount: validateLicenseRenewalResponse.chargeAmount,
                accessToken: validateLicenseRenewalResponse.accessToken,
                licenseStatus: validateLicenseRenewalResponse.licenseStatus,
                finishDate: validateLicenseRenewalResponse.finishDate,
                basePrice: validateLicenseRenewalResponse.basePrice,
                appVariant: validateLicenseRenewalResponse.appVariant,
                key: key,
                referralCode: referralCode,
            });
        } catch (error) {
            this.setState({
                errorMessage: error.getApiErrorDetails().message,
            });
        } finally {
            this.setState(state => ({
                fetching: state.fetching - 1,
            }));
        }
    };
    
    generateImageContainer = (imageUrl) => {
        return (
            <FlexContainer direction="row" alignItems="center">
                <img src={imageUrl} alt={"Company Logo"} style={{ height: "29px", objectFit: "contain" }} />
            </FlexContainer>
        );
    };

    render() {
        const { children } = this.props;

        if (this.state.fetching > 0) {
            return (
                <FlexContainer padding="2rem 2rem" style={{ margin: "auto" }}>
                    <Text size="30px" color="#000" weight="500">
                        Please wait while we connect you to your account...
                    </Text>
                </FlexContainer>
            );
        }

        return (
            <FlexContainer
                color="#FFF"
                family="Manrope, Helvetica, sans-serif"
                style={{ 
                    minHeight: "100vh",    
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                }}
            >
                <LicenseHeader logoImg={this.state.businessLogo} backgroundColor={this.state.backgroundColor} />

                { !this.state.isValidLicenseRenewalKey && <UserCannotBeFound errorMessage={this.state.errorMessage} /> }

                { this.state.isValidLicenseRenewalKey &&
                    <LicenseRenewalContainerContext.Provider value={{
                        businessLogo: this.state.businessLogo,
                        backgroundColor: this.state.backgroundColor,
                        licenseTermDuration: this.state.licenseTermDuration,
                        licenseTermDurationUnit: this.state.licenseTermDurationUnit,
                        licenseTermAmount: this.state.licenseTermAmount,
                        isAustralian: this.state.isAustralian,
                        gstAmount: this.state.gstAmount,
                        processingFee: this.state.processingFee,
                        currency: this.state.currency,
                        chargeAmount: this.state.chargeAmount,
                        accessToken: this.state.accessToken,
                        key: this.state.key,
                        referralCode: this.state.referralCode,
                        employeeName: this.state.employeeName,
                        businessName: this.state.businessName,
                        licenseStatus: this.state.licenseStatus,
                        finishDate: this.state.finishDate,
                        basePrice: this.state.basePrice,
                        appVariant: this.state.appVariant
                    }}>
                        {children}
                    </LicenseRenewalContainerContext.Provider>
                }

                <LicenseFooter appVariant={this.state.appVariant} />
            </FlexContainer>
        );
    }
}

class UserCannotBeFound extends Component {
    render() {
        return (
            <FlexContainer style={{ margin: "auto" }}>
                <Text size="30px" color="#000" weight="500">
                    Please wait while we connect you to your account...
                </Text>

                <Text margin="10px" size="16px" color="#000" weight="500">
                    {this.props.errorMessage}
                </Text>
            </FlexContainer>
        );
    }
}

class LicenseHeader extends Component {
    render() {
        const { top, url, transparent, logoImg, backgroundColor } = this.props;

        return (
            <Container transparent={transparent} top={top} url={url} backgroundColor={backgroundColor}>
                <Content>
                    <Logo>
                        {logoImg}
                    </Logo>
                </Content>
            </Container>
        );
    }
}

export class LicenseFooter extends Component {
    render() {
        const app = getAppDetails(this.props.appVariant);
        const logo = this.props.appVariant === AppVariant.CHECKED_IN ? CheckedInLogo : MeBusinessLogo;

        return (
            <FooterBox backgroundColor={app.brandBackgroundColor}>
                <FooterContainer>
                    <OphPowerContainer>
                        <OphLink href={app.websiteUrl} target="_blank" rel="noopener noreferrer">
                            <OphImage src={logo} alt={app.brandName} />
                        </OphLink>
                    </OphPowerContainer>

                    <FooterLinksContainer>
                        <FooterLink href={app.termsUrl} target="_blank" rel="noopener noreferrer">
                            Terms &amp; Conditions
                        </FooterLink>
                        <FooterLink href={app.privacyUrl} target="_blank" rel="noopener noreferrer">
                            Privacy Policy
                        </FooterLink>
                        <FooterLink href={`mailto:${app.supportEmail}`}>
                            Contact Us
                        </FooterLink>
                    </FooterLinksContainer>

                    <OphPowerContainer>
                        <OphFooterImage src={OnPointLogo} />
                    </OphPowerContainer>

                    <CopyrightText>©2026 {app.brandName}. All rights reserved.</CopyrightText>
                </FooterContainer>
            </FooterBox>
           
     
        );
    }
}

export default LicenseRenewalContainer;
